// extracted by mini-css-extract-plugin
module.exports = {"icon":"facilityContact_icon__1D2IL"};